import React, {useRef}from 'react'
import axios from 'axios'
import $ from 'jquery'
export default function Footer() {
   
    const footer_bg = {
        background: "url('/Images/footer_bg.jpg') no-repeat fixed center"
    }
    

    // setting refs for contact name, email, and comment
    const [nameRef,emailRef,commentRef] = [useRef(),useRef(),useRef()]

    const contactSubmit = () =>{
     const contactInfo = {
         name:nameRef.current.value,
         email:emailRef.current.value,
         comment:commentRef.current.value
     }
     
    if(contactInfo.name == "" || contactInfo.email == ""){
        $('.submit').text("Please enter name and email").addClass('badge-danger').fadeIn().fadeOut(10000)
        
    }else{
        $('.submit').text("Submitted! Looking forward to working with you!").removeClass('badge-danger').addClass('badge-success').fadeIn()
        axios.post(`http://www.rumdone.com/contact`,contactInfo)
    }
     // reset values
     nameRef.current.value = null
     emailRef.current.value = null
     commentRef.current.value = null
    }
    return (
        <div><br /><br />
            <div className="container-flex  my-auto">
                <div className="row p-3 w-75 mx-auto">
                    <div className="col-sm-12 col-md-6 col-lg-6 mx-auto  "><br/>
                        <h3 className="m-2 text-center ">Let's create something together!</h3><br/>
                        <div className="icons m-2 p-2">
                            <a href=""><img className="m-2" src="./Images/icons/facebook.svg" alt=""/></a>
                            <a href=""><img className="m-2" src="./Images/icons/instagram.svg" alt=""/></a>
                            <a href=""><img className="m-2" src="./Images/icons/pinterest.svg" alt=""/></a>
                            
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 p-5 border">
                                <img src="./Images/icons/email_icon.svg" alt="" />
                            </div>
                            <div className="col-sm-12 col-md-6 pt-5 pb-5 border">
                                <p className="pt-3">Pers2140@gmail.com</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 p-5 border">
                                <img src="./Images/icons/phone_icon.svg" alt="" />
                            </div>
                            <div className="col-sm-12 col-md-6 pt-5 pb-5 border">
                                <p className="pt-3">860-553-3304</p>
                            </div>
                        </div>


                    </div>
                    <div className=" col-sm-12 col-md-6 col-lg-6 ">
                        <form className="w-100 mx-auto">
                            <div className="form-group">
                                <label className="m-1" htmlFor="name">* Name: </label>
                                <input  ref={nameRef} className="form-control" id="name" type="text"  />
                            </div>
                            <div className="form-group">
                                <label className="m-1" htmlFor="email">* Email:  </label>
                                <input ref={emailRef} className="form-control" id="email" type="text"  />
                            </div>
                            <label className="m-1" htmlFor="help">How can I help?</label>
                            <div className="form-group">
                                <textarea ref={commentRef} className="form-control" name="help" id="" cols="10" rows="10"></textarea>
                            </div>
                            <div onClick={contactSubmit} className="btn btn-dark float-right">Submit</div>
                            <span className="badge submit p-2"></span>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}
